module.exports = __webpack_public_path__ + "img/upload2.971cc2b4.png";